import axios from "@/plugins/axios";

const getAll = (params) => {
  return axios.get("/task", { params });
};

const getOne = (id) => {
  return axios.get(`/task/${id}`);
};

const force = (id) => {
  return axios.post(`/task/${id}/force`);
};

const rerun = (id) => {
  return axios.post(`/task/${id}/rerun`);
};

const cancel = (id) => {
  return axios.delete(`/task/${id}`);
};

const getTypes = () => {
  return axios.get(`/task/types`);
};

const createDeletionTask = (id) => {
  return axios.post(`/task/${id}/post-deletion`);
};

const kill = (id) => {
  return axios.post(`/task/${id}/kill`);
};

const forceResume = (id) => {
  return axios.post(`/task/${id}/force-resume`);
};

export default {
  getAll,
  getOne,
  force,
  rerun,
  cancel,
  getTypes,
  createDeletionTask,
  kill,
  forceResume,
};
